import React from "react";
import { Card } from "react-bootstrap";

const KafkaHealth = ({ health }) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header>
        <Card.Title>Apache Kafka</Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-center align-items-center">
          <div
            className={`circle ${
              health === "UP"
                ? "pulse green"
                : health === "DOWN"
                ? "red"
                : "blue"
            }`}
            style={{
              width: "25px",
              height: "25px",
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default KafkaHealth;
